export default "__VITE_ASSET__CEAdRY6w__"